<template>
	<!-- eslint-disable-next-line -->
	<div
		:class="
		$store.state.settingsSlider.SLIDER_IS_OPEN
			? 'settingsSlider settingsSlider_opened'
			: 'settingsSlider settingsSlider_closed'
		"
		>
		<div class="buttonBody">
			<button v-if="!$store.state.settingsSlider.SLIDER_IS_OPEN" id="sliderButton" @click="toggleSlider">
				<font-awesome-icon icon="cogs"></font-awesome-icon>
			</button>

			<div
				class="h-full bg-grey-darker hover:bg-grey-dark cursor-pointer text-lg text-white pt-10"
				@click="toggleSlider"
				v-if="$store.state.settingsSlider.SLIDER_IS_OPEN"
				>
				<font-awesome-icon icon="chevron-right"></font-awesome-icon>
			</div>
		</div>

		<div id="settings_body">
			<div id="heading">Site settings</div>

			<div class="w-full formItem">
			<div class="w-full labeldiv">
					<label>
						Display area in
					</label>
				</div>

				<v-select
					placeholder="Display area in."
					:options="areaOptions"
					:onChange="
					data => {
						onSelectedAreaUnitChange(data.value);
					}
					"
					class="rounded bg-white hover:border-grey mt-1 mx-4"
					>
				</v-select>
			</div>

			<div class="w-full formItem">
			<div class="w-full labeldiv">
					<label>
						Display weight in
					</label>
				</div>

				<v-select
					placeholder="Select unit for weight."
					:options="weightUnitsList"
					:onChange="
						data => {
							onSelectedWeightUnitChange(data);
						}
					"
					class="rounded bg-white hover:border-grey mt-1 mx-4"
				>
				</v-select>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "SettingsSlider",
	data() {
		return {
			weightUnitsList: this.$store.state.globalSettings.WEIGHTS_LIST,
			areaOptions: [
				{ value: "acre", label: "Acres" },
				{ value: "hectare", label: "Hectares" },
				{ value: "squarekilometer", label: "Square Kilometres" },
				{ value: "squaremetre", label: "Square Metres" },
				{ value: "squaremile", label: "Square Miles" },
				{ value: "squareyard", label: "Square Yard" },
				{ value: "squarefoot", label: "Square Feet" },
				{ value: "squareinch", label: "Square Inchs" },
			],
		};
	},
	methods: {
		onSelectedAreaUnitChange(a) {
			this.$store.commit("globalSettings/setGlobalAreaUnit", {
				value: a,
			});
		},
		onSelectedWeightUnitChange(a) {
			this.$store.commit("globalSettings/setGlobalWeightUnit", a);
		},
		toggleSlider() {
			this.$store.commit("settingsSlider/toggleSlider");
		},
	},
};
</script>

<style scoped type="SCSS">
.settingsSlider_opened {
	position: absolute;
	right: 0;
	z-index: 5;
	background: rgba(59, 97, 115, 0.99099);
	height: calc(100% - 76px); /* the 76 is from the fact the menu is 76 px tall*/
	width: 325px;
	animation-name: stretchLeft;
	animation-timing-function: ease-out;
	animation-duration: 0.2s;
	transform-origin: 100% 0%;
}
#sliderButton {
	background-color: rgb(52, 144, 220);
	border: 1px solid rgb(52, 144, 220);
	border-radius: 50%;
	color: rgb(255, 255, 255);
	cursor: pointer;
	font-size: 18px;
	height: 40px;
	padding: 0px;
	position: relative;
	top: 175px;
	width: 40px;
	z-index: 9999;
}
.settingsSlider_opened #heading {
	font-size: 25px;
	color: #e4e4e4;
	border-bottom: solid 2px #606f7b;
	margin: 12px 56px 44px 56px;
}
.settingsSlider_opened label {
	color: #fff;
}
.settingsSlider_opened .formItem {
	padding-bottom: 20px;
}
.settingsSlider_opened .labeldiv {
	padding-top: 2px;
}
.settingsSlider_closed {
	position: absolute;
	right: 0px;
	z-index: 5;
	height: 94%;
	width: 50px;
	transition-property: all;
	transition-duration: 0.2s;
}
.settingsSlider_closed #sliderButton {
}

@keyframes stretchLeft {
	0% {
		transform: scaleX(0.3);
	}
	40% {
		transform: scaleX(1.02);
	}
	60% {
		transform: scaleX(0.98);
	}
	80% {
		transform: scaleX(1.01);
	}
	100% {
		transform: scaleX(0.98);
	}
	80% {
		transform: scaleX(1.01);
	}
	100% {
		transform: scaleX(1);
	}
}
.buttonBody {
	display: inline;
	height: 100%;
	width: 50px;
	position: absolute;
	left: 0px;
}
#settings_body {
	display: inline;
	height: 100%;
	width: 325px;
	position: absolute;
	left: 0px;
	background-color: #191e23;
}
.settingsSlider_closed #settings_body {
	display: inline;
	height: 100%;
	width: 0px;
	position: absolute;
	left: 0px;
	overflow: hidden;
}
.settingsSlider_opened .buttonBody {
	left: -50px;
}
.settingsSlider {
	font-weight: 200;
}
</style>
